<tt-page>
    <tt-page-heading [ttModel]="!p2UpdateScriptKeyno || p2UpdateScriptKeyno === '0' ? 'h_update_script_new' : 'h_update_script_edit'" ttTranslate></tt-page-heading>
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-p2-update-script-edit [p2UpdateScriptKeyno]="p2UpdateScriptKeyno" (onSave)="onSave()"></tt-p2-update-script-edit>
    </tt-card>
</tt-page>
